import { RowSelectionProvider } from "@/contexts/RowSelection/RowSelectionProvider";

export function RecordProviders({ children }: { children: React.ReactNode }) {
  return <RowSelectionProvider>{children}</RowSelectionProvider>;
}
